import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class MyExternalTokensService extends RestfulService<Models.MyExternalToken> {

  constructor(public restService: RestService) {
    super(Models.MyExternalToken);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('my-external-tokens');
  }
}
